import React from 'react';
import { useIntl } from 'react-intl';
import messages from './FieldMessages';
import EnumChange from './EnumChange';
import FieldChange from './FieldChange';

const NaceCodePropertyChange = props => {
  const intl = useIntl();
  const { log, users, relations } = props;

  const isEnum = () => {
    const value = log.oldValue.Value || log.newValue.Value;
    return value && value.hasOwnProperty('Value') && value.hasOwnProperty('Name');
  };

  const displayLogLine = () => {
    const transformedLogLine = {
      ...log,
      oldValue: log.oldValue.Value,
      newValue: log.newValue.Value,
    };

    if (isEnum()) {
      return <EnumChange log={transformedLogLine} />;
    }

    return <FieldChange log={transformedLogLine} users={users} relations={relations} />;
  };

  return (
    <span>
      {displayLogLine()}{' '}
      {log.displayValue
        ? intl.formatMessage(messages.NaceCodeWithDisplayValueProperty, {
            code: log.displayValue,
            b: value => <b>{value}</b>,
          })
        : intl.formatMessage(messages.NaceCodeProperty)}
    </span>
  );
};

export default NaceCodePropertyChange;
